import { useContext } from 'react';
import { GameContext } from 'contexts/GameContext';
import { Cell as CellElement, Content } from 'elements/Table';
import { Small, Span } from 'elements/Text';

const Cell = ({ position, across }) => {
  const {
    actions: { select },
    grid, guesses, check, gridnums, size, cursor,
    selected, highlighted,
  } = useContext(GameContext);

  return (
    <CellElement
      onClick={() => select({ position, across })}
      numCols={size.cols}
      blank={grid[position] === '.'}
      isTarget={position === cursor.position}
      selected={selected[position]}
      highlighted={highlighted[position]}
      square
    >
      <Content
        display="flex"
        flexDirection="row"
        alignItems="center" 
        hasError={
          check[position] && guesses[position] !== ' ' && guesses[position] !== grid[position]
        }
      >
        {grid[position] !== '.' && <Span textAlign="center" width="100%">{guesses[position]}</Span>}
        {!!gridnums[position] && <Small position="absolute" top="0">{gridnums[position]}</Small>}
      </Content>
    </CellElement>
  )
}

export default Cell;
